var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-690 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5336",
    "data-name": "Group 5336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 128,
    height: 128,
    transform: "translate(690 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logout-2",
    "data-name": "logout",
    transform: "translate(690.973 528.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M299.078,168.34a5.308,5.308,0,0,1,1.14-1.712l15.752-15.753A5.252,5.252,0,0,1,323.4,158.3l-6.792,6.792h29.341a5.253,5.253,0,0,1,0,10.505H316.606l6.792,6.792a5.252,5.252,0,1,1-7.427,7.427l-15.752-15.753a5.2,5.2,0,0,1-1.14-1.712A5.258,5.258,0,0,1,299.078,168.34Z",
    transform: "translate(-298.68 -112.569)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M5.267,73.536a5.251,5.251,0,0,1,5.253,5.252v26.263h21.01V21.01a5.259,5.259,0,0,1,3.745-5.032l18.242-5.473h-43V36.768a5.252,5.252,0,0,1-10.5,0V5.253A5.251,5.251,0,0,1,5.267,0H89.308a4.681,4.681,0,0,1,.541.1,5.188,5.188,0,0,1,2.227.777c.115.074.257.079.368.163.042.032.058.09.1.121a5.2,5.2,0,0,1,1.4,1.66,4.291,4.291,0,0,1,.147.441A4.982,4.982,0,0,1,94.5,4.491a3.27,3.27,0,0,1-.016.457c.005.105.074.2.074.3V110.3a5.249,5.249,0,0,1-4.223,5.148L37.811,125.957a4.888,4.888,0,0,1-1.029.105,5.256,5.256,0,0,1-5.252-5.253v-5.253H5.267A5.251,5.251,0,0,1,.014,110.3V78.789A5.251,5.251,0,0,1,5.267,73.536Z",
    transform: "translate(31.495)",
    fill: "#90205d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bf834638.svg";
export { ForwardRef as ReactComponent };